"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unparse = void 0;

var utils_1 = require("./utils"); // **`unparse()` - Convert UUID byte array (ala parse()) into a string**


var unparse = function unparse(buf, offset) {
  var i = offset || 0;
  var bth = utils_1.byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
};

exports.unparse = unparse;